function getSupportsMatchMedia() {
    return 'undefined' != typeof window && void 0 !== window.matchMedia;
}
const FALLBACK_BREAKPOINT = 'xl';
const getFallbackMatchMedia = (matches)=>({
        matches: matches,
        media: '',
        onchange: ()=>{},
        addListener: ()=>{},
        removeListener: ()=>{},
        addEventListener: ()=>{},
        removeEventListener: ()=>{},
        dispatchEvent: ()=>true
    });
export { FALLBACK_BREAKPOINT, getFallbackMatchMedia, getSupportsMatchMedia };

//# sourceMappingURL=fallbackMatchMediaUtils.js.map